import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, ArrowUp } from 'lucide-react';
import { socialLinks } from '../data/mockData';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_visuals-by-kate/artifacts/t0c5kpd1_IMG_0438.jpeg";

const navigationLinks = [
  { label: "About", href: "/#about" },
  { label: "Services", href: "/#services" },
  { label: "Portfolio", href: "/#portfolio" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/#contact" }
];

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  const socialIcons = {
    Instagram: Instagram,
    LinkedIn: Linkedin,
    TikTok: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
      </svg>
    )
  };

  return (
    <footer className="bg-[#0a0a0a] text-white border-t border-[#2a2a2a]">
      <div className="container">
        {/* Main Footer */}
        <div className="py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Brand */}
            <div className="lg:col-span-2">
              {/* Logo */}
              <Link to="/" className="inline-block mb-6">
                <img 
                  src={LOGO_URL} 
                  alt="Kate Samuilova - Social Growth" 
                  className="h-16 w-auto object-contain"
                  style={{ 
                    mixBlendMode: 'lighten'
                  }}
                />
              </Link>
              <p className="body-regular text-[#808080] max-w-md mb-6">
                London-based content creator and social media manager helping restaurants, cafés, hotels, and beauty brands grow their online presence.
              </p>
              
              {/* Social Links */}
              <div className="flex items-center gap-4">
                {socialLinks.map((social) => {
                  const IconComponent = socialIcons[social.platform];
                  return (
                    <a
                      key={social.platform}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 border border-[#2a2a2a] flex items-center justify-center text-[#808080] hover:border-[#c9a962] hover:bg-[#c9a962] hover:text-[#0a0a0a] transition-all duration-300"
                      aria-label={social.platform}
                    >
                      {IconComponent && <IconComponent />}
                    </a>
                  );
                })}
              </div>
            </div>
            
            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-medium uppercase tracking-wider mb-6 text-[#c9a962]">Navigation</h4>
              <ul className="space-y-3">
                {navigationLinks.map((link) => (
                  <li key={link.label}>
                    <Link 
                      to={link.href}
                      className="body-regular text-[#808080] hover:text-[#c9a962] transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Contact */}
            <div>
              <h4 className="text-sm font-medium uppercase tracking-wider mb-6 text-[#c9a962]">Contact</h4>
              <ul className="space-y-3">
                <li>
                  <a 
                    href="mailto:katedigitallondon@gmail.com"
                    className="body-regular text-[#808080] hover:text-[#c9a962] transition-colors"
                  >
                    katedigitallondon@gmail.com
                  </a>
                </li>
                <li className="body-regular text-[#808080]">
                  London, United Kingdom
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Bottom Footer */}
        <div className="py-6 border-t border-[#2a2a2a] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="body-small text-[#808080]">
            © {currentYear} Kate Samuilova. All rights reserved.
          </p>
          
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-[#808080] hover:text-[#c9a962] transition-colors"
            aria-label="Back to top"
          >
            <span className="body-small">Back to top</span>
            <ArrowUp size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
